<template>
  <AntProvider>
    <AppPlatform>
      <NuxtPage />
    </AppPlatform>
    <ClientOnly>
      <XModal />
    </ClientOnly>
  </AntProvider>
</template>

<script lang="ts" setup>
import { useSeo } from './hooks/useSeo'
import AntProvider from './features/provider/instance.vue'
import AppPlatform from './app-platform.vue'
import { useAntCss } from '~/hooks/useAntCss'
import { XModal } from '@/features/modal'

useSeo()

const area = getEnv('area') as 'CN' | 'US'

const currentTheme = useTheme()

currentTheme.value = area === 'CN' ? 'light' : 'dark'

useAntCss(currentTheme)

useHead({
  htmlAttrs: {
    class: () => {
      return currentTheme.value
    },
  },
})
</script>
